/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AUMSSelectionPortionResponse
 */
export interface AUMSSelectionPortionResponse {
    /**
     * 
     * @type {number}
     * @memberof AUMSSelectionPortionResponse
     */
    'portion'?: number;
    /**
     * 
     * @type {string}
     * @memberof AUMSSelectionPortionResponse
     */
    'type'?: AUMSSelectionPortionResponseTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AUMSSelectionPortionResponse
     */
    'calories'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSSelectionPortionResponse
     */
    'protein'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSSelectionPortionResponse
     */
    'carbs'?: number;
    /**
     * 
     * @type {number}
     * @memberof AUMSSelectionPortionResponse
     */
    'fat'?: number;
}

export const AUMSSelectionPortionResponseTypeEnum = {
    Default: 'DEFAULT',
    Assigned: 'ASSIGNED',
    Customized: 'CUSTOMIZED'
} as const;

export type AUMSSelectionPortionResponseTypeEnum = typeof AUMSSelectionPortionResponseTypeEnum[keyof typeof AUMSSelectionPortionResponseTypeEnum];


